export function agGridStringComparator(val1: string, val2: string): number {
  try {
    return val1?.toLocaleLowerCase()?.localeCompare(val2?.toLocaleLowerCase());
  } catch {
    return 0;
  }
}
